export default __webpack_public_path__ + "static/media/poonsung.2c8feae7.png";